<div class="grid bg-white -m-4 p-4" *ngIf="details">
	<div class=" col-12">
		<p-breadcrumb styleClass="bg-white text-600 border-none" [model]="[{label:'TOUS LES JEUX',routerLink: '/games'},{label:game.name}]" [home]="{icon: 'pi pi-home', routerLink: '/'}">
			<ng-template pTemplate="item" let-item>
				<span>{{item.label | translate}}</span>
			</ng-template>
		</p-breadcrumb>
	</div>
	
	<div class="col-12 sm:col-9">
		<div class="flex align-items-justify justify-content-around">
			<img alt="{{game.name_item}}" class="m-auto" *ngIf="game && game.logo;else title" src="https://cdn.blackrockgames.fr/items/{{game.Id}}/{{game.logo}}?width=600" pTooltip="{{game.name}}"/>
			<ng-template #title>
				<h1  class="text-center uppercase text-100">{{game.name}}</h1>
			</ng-template>
		</div>
		<div class="grid text-gray-900">
			<div class="col-12 text-200 flex justify-content-evenly">
				<div class="text-center" pTooltip="{{'age' | translate}}" tooltipPosition="top" *ngIf="game.age_min > 0">
					<img src="/assets/age.jpg" height="40" /><br/>
					{{game.age_min}}{{game.age_max > 98 ? '+' : '-'+game.age_max}}
					<label *ngIf="game.age_unity != null && game.age_unity != 'ans'">{{game.age_unity}}</label>
				</div>
				<div class="text-center" pTooltip="{{'nbplayers' | translate}}" tooltipPosition="top" *ngIf="game.player_min > 0">
					<img src="/assets/players.jpg" height="40"/><br/>
					{{game.player_min}}{{game.player_max > 98 ? '+' : '-'+game.player_max}}
				</div>
				<div class="text-center"  pTooltip="{{'duration' | translate}}" tooltipPosition="top" *ngIf="game.duration > 0">
					<img src="/assets/duration.jpg" height="40"/><br/>
					{{game.duration}}'
				</div>
			</div>
			<div class="col-6 text-center" >
				<p-carousel [value]="game.imgs" [showIndicators]="false" [showNavigators]="false" [autoplayInterval]="inter" [circular]="true"	>
					<ng-template let-img pTemplate="item">

						<p-image src="https://cdn.blackrockgames.fr/items/{{game.Id}}/{{img}}?width=300" [preview]="false" (click)="showGalleria(img)"></p-image>
					</ng-template>
				</p-carousel>
				<button pButton label="{{'Télécharger les visuels' | translate}}" (click)="api.pro ? downloadPhotos('j\'ai besoin des visuels') : showPass =  true"></button>
			</div>
			<div class="col-6 flex flex-column align-items-justify justify-content-around ">
				<ng-container *ngIf="api.pro">
					<div>
						<div class="flex justify-content-around mb-2">
							<div class="text-center text-600 font-medium text-2xl relative">
								<span class="">{{game.priceHT | currency:'EUR'}}</span>
								<span class="text-xs absolute right-0" style="top:-10px"> Brut HT</span>
							</div>
							<div class="text-center text-100 font-medium text-4xl relative">
								{{game.priceHT - (game.priceHT * game.discountRate/100) | currency:'EUR'}}
								<span class="text-xs absolute right-0" style="top:-10px">Net HT</span>
							</div>
						</div>
	<!-- 					<div class="text-center text-100 font-bold text-4xl mb-1">
							{{game.priceHT - (game.priceHT * game.discountRateCustomer/100) | currency:'EUR'}} <span class="text-xs vertical-align-top">HT</span>
						</div> -->
						<div class="text-center text-300">
							
						</div>
					</div>
					<p-message severity="error" text="Rupture" *ngIf="game.rupture" styleClass="w-full mb-2"></p-message>
					<p-message severity="warn" text="Disponible {{game.out_date_date | date:'MMMM YYYY'}}" *ngIf="!game.orderable && api.reassorts && !api.reassorts[game.Id]" styleClass="w-full mb-2"></p-message>
					<!-- <p-message *ngIf="game.Id == 'CAT080CO'" severity="warn" text="Contactez votre commercial" styleClass="w-full mb-2"></p-message> -->
					<p-message *ngIf="game.rupture && api.reassorts && api.reassorts[game.Id]" severity="warn" text="Disponible {{api.reassorts[game.Id].date | date:'MMMM YYYY'}}"  styleClass="w-full mb-2"></p-message>
					
					<div class="flex justify-content-around" *ngIf="!game.idInCart">
						<p-inputNumber [step]="game.step" (onBlur)="api.roundToStep(game)" [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" [min]="0" inputStyleClass="w-3rem text-center py-2 px-1 border-transparent surface-800 text-300" [(ngModel)]="game.quantity" 
						class="border-1 surface-border border-round" decrementButtonClass="p-button-text py-1 px-1" incrementButtonClass="p-button-text py-1 px-1" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>

						<button pTooltip="Ajouter à mes favoris" pButton (click)="setFavorite()" icon="pi {{isFav() ? 'pi-heart-fill' : 'pi-heart'}}" pRipple class="p-button-rounded p-button-outlined " *ngIf="api.user"></button>

						<button [disabled]="!game.orderable " class="shadow-5 active:shadow-1" pButton pRipple label="Ajouter au panier" icon="pi pi-shopping-cart" (click)="addToCart()" ></button>
					</div>
					<div class="flex justify-content-around" *ngIf="gameInCart && game.idInCart">
						<p-inputNumber (onInput)="gameInCart.quantity = $event.value;api.changeQty(gameInCart);$event.value < 1 ? gameInCart = undefined : ''" [showButtons]="true" buttonLayout="horizontal" spinnerMode="horizontal" [min]="0" inputStyleClass="w-3rem text-center py-2 px-1 border-transparent surface-800 text-300" [(ngModel)]="gameInCart.quantity" 
						[step]="game.step"	class="border-1 surface-border border-round" decrementButtonClass="p-button-text py-1 px-1" incrementButtonClass="p-button-text py-1 px-1" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"></p-inputNumber>
					</div>

					<div class="mt-2 grid">
						<ng-container *ngFor="let o of api.offers">
							<div appendTo="body" tooltipPosition="top" pTooltip="{{evalReturn(o.description)}}" class="cursor-pointer col-6 text-center" *ngIf="game.authorizedOffers.indexOf(o.id_offer) > -1">
								<!-- <span class="text-200 font-medium">{{o.name_offer}}</span> -->
								<button [disabled]="!game.orderable" class="w-full shadow-5 p-button-secondary active:shadow-1 font-medium" icon="pi pi-info-circle" pButton pRipple label="{{o.name_offer}}" (click)="chooseOffer(o)" ></button>
							</div>

						</ng-container>
					</div>
				</ng-container>
				<h1 *ngIf="!api.pro" class="text-left uppercase text-100 my-0">{{game.name}}</h1>
				<p >{{api.pro || details.description_brg == null || details.description_brg == '' ? details.presentation_text : details.description_brg | trim}}</p>
			</div>
			<div class="col-12 border-none border-top-1 border-solid border-400">
				<h2 class="text-200" *ngIf="!api.pro && details.opinion_brg != null">L'avis de la Blackrock Family</h2>
				<p>{{api.pro || details.opinion_brg == null || details.opinion_brg == '' ? details.mechanical_text : details.opinion_brg | trim}}</p>
			</div>
			<div class="col-6 border-none border-top-1 border-solid border-400" *ngIf="papers">
				<h2 class="text-200">{{'Revue de presse' | translate}}</h2>
				<ul>
					<li *ngFor="let row of papers">
						<a href="{{row.link}}" target="blank" >{{row.text}}</a>
					</li>
				</ul>
			</div>
			<div class="col-6 border-none border-top-1 border-solid border-400" *ngIf="details.presentation_video != null">
				<div class="video-container">
					<iframe width="560" height="315" [src]="details.presentation_video | safeUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				</div>
			</div>
			<div class="col-12 border-none border-top-1 border-solid border-400" *ngIf="details.rules && details.rules.length > 0">
				<h2 class="text-200">{{'Règles du jeu' | translate}}</h2>
				<div class="flex justify-content-start">
					<a href="https://cdn.blackrockgames.fr/items/{{rule.folder}}/{{rule.key}}.pdf" target="_blank" class="cursor-pointer m-2" *ngFor="let rule of details.rules" pTooltip="{{rule.key}}" tooltipPosition="top">
						<img src="https://cdn.blackrockgames.fr/items/{{rule.folder}}/{{rule.key}}.pdf?width=600" />
					</a>
				</div>
			</div>
		</div>
	</div>
	<div class="col-12 sm:col-3 text-center">
		<img pTooltip="{{game.name_editor}}" alt="{{game.name_editor}}" [routerLink]='["/pages/"+game.familyId]'  class="cursor-pointer shadow-5" src="https://blackrockgames.fr/upload/editor/350_{{game.logo_editor}}" style="max-width: 150px; max-height: 150px;">
		<div *ngFor="let f of details.features" class="text-200 text-left">
			<b>{{f.key | translate}}<span *ngIf="f.value.indexOf('&') > -1">s</span></b> : {{f.value}}
		</div>
		<p-card header="{{'Points forts' | translate}}" styleClass="my-2 text-sm" *ngIf="details.strong_points != '' || details.strong_points != null">
            <div class="text-left">{{details.strong_points}}</div>
        </p-card>
        <p-card header="{{'Info. techniques' | translate}}" styleClass="my-2 text-sm">
            <div class="text-left">
                <div>{{'Ref.' | translate}} : <b>{{game.Id}}</b></div>
                <div>{{'EAN' | translate}} : <b>{{game.BarCode}}</b></div>
                <div *ngIf="game.OriginCountry != null">{{'Made in' | translate}} <span class="font-bold">{{game.OriginCountry}}</span></div>
                <div>{{'Box size'| translate}} : <span class="font-bold">{{game.Length | number: '1.0-1'}} x {{game.Width | number: '1.0-1'}} x {{game.Height | number: '1.0-1'}} cm</span></div>
                <div *ngIf="game.Weight > 0">{{'Box weight'| translate}} : <span class="font-bold">{{game.Weight | number: '1.0-1'}}g</span></div>
                <div *ngIf="game.NumberOfItemByPackage && api.pro"><span class="font-bold">{{game.NumberOfItemByPackage}}</span> {{'NumberOfItemByPackage' | translate}}</div>
            </div>
        </p-card>
        <p-card header="{{'Contenu' | translate}}" styleClass="my-2 text-sm">
            <div class="text-left">
                {{details.contain}}
            </div>
        </p-card>

        <div *ngIf="details.fiche && api.pro" class="cursor-pointer mt-2"  pTooltip="{{'Télécharger la fiche PDF' | translate}}" tooltipPosition="left">
            <a href="https://cdn.blackrockgames.fr/items/{{game.Id}}/fiche-produit.pdf" target="_blank">
				<img src="https://blackrockgames.fr/images/items/{{game.Id}}/fiche-produit.pdf" />
			</a>
        </div>
        <div *ngIf="details.decla_ce && api.pro" class="mt-4 text-200 cursor-pointer">
            <i class="pi pi-download"></i><a href="https://cdn.blackrockgames.fr/items/{{game.Id}}/amazon.pdf" target="_blank" class="ml-2  underline">{{'Déclaration de conformité CE' | translate}}</a>
        </div>
	</div>
</div>

<p-galleria *ngIf="details" [value]="game.imgs" [(visible)]="displayGalleria" [(activeIndex)]="imgIndex" [circular]="true" [fullScreen]="true" [showItemNavigators]="true" [containerStyle]="{'max-width': '95vw', 'max-height':'95vh'}" [numVisible]="4" > 
	<ng-template pTemplate="item" let-id>
		<div class="imgContainerInGalleria">
			<img loading="lazy" src="https://cdn.blackrockgames.fr/items/{{game.Id}}/{{id}}?width=1024" style="max-height: 85vh; width: auto; object-fit: contain;" />
		</div>
	</ng-template>
	<ng-template pTemplate="thumbnail" let-id>
		<img src="https://cdn.blackrockgames.fr/items/{{game.Id}}/{{id}}?width=200" class="thumb"/>
	</ng-template>
</p-galleria>


<p-dialog [(visible)]="showPass" [modal]="true" [header]="'Un mot de passe est nécessaire'">
	<div class="mb-2">
		<p-message severity="error" *ngIf="errorPass" text="Ça n'est pas exactement ça."></p-message>
	</div>
	<p-password #visualPass [feedback]="false" ></p-password>
	<ng-template pTemplate="footer">
		<div class=" border-top-1 surface-border pt-3 flex">
			<button pButton pRipple icon="pi pi-times" (click)="showPass = false" label="Annuler" class="p-button-outlined w-6 mr-2"></button>
			<button pButton pRipple icon="pi pi-check" (click)="downloadPhotos(visualPass.value)" label="Télécharger" class="w-6 ml-2"></button>
		</div>
	</ng-template>
</p-dialog>